import React from 'react';
import { Card, CardContent } from '../ui/card';
import { DollarSign, FileText } from 'lucide-react';

interface ExpenseStatsProps {
  totalAmount: number;
  count: number;
}

const ExpenseStats: React.FC<ExpenseStatsProps> = ({ totalAmount, count }) => {
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
    }).format(amount);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 rounded-lg p-3">
              <DollarSign className="w-6 h-6 text-blue-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground">Total Gastado</p>
              <p className="text-2xl font-bold">{formatCurrency(totalAmount)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="bg-indigo-100 rounded-lg p-3">
              <FileText className="w-6 h-6 text-indigo-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground">Total Gastos</p>
              <p className="text-2xl font-bold">{count}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExpenseStats;
